export default __webpack_public_path__ + "static/media/step6.8b31220c.png";